import React, { Component } from "react";
import { connect } from "react-redux";
import Constants from 'constants';
import { saveErrors } from 'actions/refreshTokenActions';
import APP from 'app';
const { Utils } = APP, { translateText } = Utils;
class Error extends Component {

    componentDidUpdate () {
        const { userId = ''} = this.props.userInfo;
        this.props.saveErrors({
            userId,
            errorInfo: "Url Not found !",
            label:"Hotel"
        })
    }

    render() {
        const imageUrl = Constants.module.STATIC_BASE_URL + "/img/error404.jpg";
        return <div className="error__page__container">
            <center>
                <div className="row error__page-height">
                    <img src={imageUrl} className="img-responsive" />
                </div>
                <div className="error__page__contnetbox">
                    <p className="error_page_paragraph">{translateText('404_errorMsg', 'errorPage')}</p>
                    <a href="/" className="btn btn-warning error_button_homepage">{translateText('goToHomePage', 'errorPage')}</a>
                    <p className="error_page_paragraph">{translateText('orExploreBy', 'errorPage')}</p>
                    <a href="/flight" className="error_button_link">{translateText('flightBooking', 'errorPage')}</a>
                    <a href="#" className="error_button_link">{translateText('hotelBooking', 'errorPage')}</a>
                </div>
            </center>
        </div>
    }
}

const mapStateToProps = state => {
    const { userInfo = {} } = state.userinfos;
    return  {
        userInfo
    }
};

const mapDispatchToProps = dispatch => ({
    saveErrors(payload) {
        dispatch(saveErrors(payload))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Error);
